import { WarningFilled } from '@ant-design/icons'
import { Form, Input, Modal, Typography } from 'antd'
import * as PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import SearchField from './searchFields/SearchField'
import { SEARCH_PRICE_LISTS_QUERY } from '@dentolize/clinic-mobile/src/shared/store/queries/appointmentQueries'

const ConfirmDeleteModal = ({ formVisible, setFormVisible, fieldName, title, handleSubmit, forPriceList }) => {
  const [fieldVal, setFieldVal] = useState('')
  const [priceList, setPriceList] = useState(null)

  const { t } = useTranslation()
  const [form] = Form.useForm()

  useEffect(() => {
    setFieldVal('')
    setPriceList(null)
    if (priceList) {
      form.setFieldsValue({
        priceList: null
      })
    }
  }, [formVisible])

  const handleConfirm = () => {
    setFormVisible(false)
    handleSubmit(fieldVal, priceList)
  }

  return (
    <Modal
      okText={t('common.confirm')}
      cancelText={t('common.cancel')}
      onOk={handleConfirm}
      okButtonProps={{ type: 'primary', danger: true, disabled: fieldVal !== fieldName }}
      onCancel={() => setFormVisible(false)}
      open={formVisible}
      destroyOnClose
    >
      <Typography.Title level={4} type="danger">
        <WarningFilled /> Warning!
      </Typography.Title>
      <Typography.Text strong>{title}</Typography.Text>
      <br />
      <Typography.Text>
        {t('common.deleteFieldConfirm1')} ({' '}
        <Typography.Text mark strong>
          {fieldName}
        </Typography.Text>{' '}
        ) {t('common.deleteFieldConfirm2')}
      </Typography.Text>
      <br />
      <br />
      <Input
        autoFocus
        value={fieldVal}
        onChange={e => setFieldVal(e.target.value)}
        onPressEnter={handleConfirm}
        placeholder={t('common.name')}
      />
      <br />
      <br />
      {forPriceList ? (
        <Form form={form}>
          <SearchField
            GET_QUERY={SEARCH_PRICE_LISTS_QUERY}
            placeholder={t('settings.procedures.newPriceList')}
            fieldName="priceList"
            dataName="searchPriceLists"
            allowClear
            filterPriceLists
            onSelect={setPriceList}
          />
        </Form>
      ) : null}
    </Modal>
  )
}

ConfirmDeleteModal.propTypes = {
  formVisible: PropTypes.bool.isRequired,
  setFormVisible: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  fieldName: PropTypes.string,
  forPriceList: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired
}

export default ConfirmDeleteModal
